import { computed, inject } from 'vue';
export const CREATE_PRESENTATION = Symbol('create-presentation');
export const CREATE_CONTROLS = Symbol('create-controls');
export function useCreatePresentation() {
    const view = inject(CREATE_PRESENTATION, undefined);
    return computed(() => view?.value);
}
export function useCreateControls() {
    const controls = inject(CREATE_CONTROLS, undefined);
    return computed(() => controls?.value);
}
